import { KNIGHT_ARC_SWEEP_MS } from './knight_cross_arc'
export const KNIGHT_LEAP_AIR_MS = 300
export const KNIGHT_LEAP_SCRAPE_MS = 260
export function knightLeapDistance(ms: number, cap: number): number {
  const distance = Math.min(180, Math.max(0, cap))
  const air = distance * 150 / 180
  const scrape = distance - air
  if (ms < KNIGHT_LEAP_AIR_MS) {
    const u = Math.min(1, Math.max(0, ms / KNIGHT_LEAP_AIR_MS))
    return air * u * (1.3 - 0.3 * u)
  }
  const u = Math.min(1, Math.max(0, (ms - KNIGHT_LEAP_AIR_MS) / KNIGHT_LEAP_SCRAPE_MS))
  return air + scrape * (1 - (1 - u) ** 2)
}
/** 跳び下がりの間の本体の浮き (px・上が −)。本体の絵 (render.ts knightMoveBodyPose) と槍の軌跡の帯が同じ高さを使う。 */
export function knightLeapLiftY(ms: number): number {
  if (ms < 0 || ms >= KNIGHT_LEAP_AIR_MS) return 0
  const u = ms / KNIGHT_LEAP_AIR_MS
  return -48 * u * (1 - u)
}

// 切り下がり = 詰めて→払って→跳び下がる (2026-10-01 ユーザー「一回前に詰めてから薙ぎ払って下がるようにするとかすれば」
//   →「作る・近い時は踏み込みを縮める」)。それまでは跳び下がりながら払い、当たりが穂先より先まで届いていた
//   (光が「どうしても前にエフェクトが出ていってるように見える」・当たりを穂先に縮めると「攻撃も当たらない」)。
//   0〜LUNGE: 薙ぎと同じ絵 (lanceSweep_contact) で前へ踏み込む (最大 90px・主人公の手前で止まる)。
//   HOP_AT から今までの跳び下がり (浮き 300ms・擦り 260ms)。
//   2026-10-01 夕 HOP_AT 220 → 150 (= 踏み込みの終わり・当たる瞬間) (ユーザー「切り下がりは薙いでから後ろに飛んでるな。
//   当たる瞬間くらいから後ろに飛んでほしい」「それに応じて絵も自然に切り替えてほしい」)。それまでは払い切り (active の終わり 220ms)
//   まで止まってから跳んでいた。当たりは active 220ms のまま騎士と一緒に動く = 跳び始めの 70ms は下がりながら払い抜ける。
//   絵は跳び始めと同じ瞬間に leap_swing (槍を前へ残したまま体が後ろへ跳ぶ) へ替わる (boss_pose_timeline.ts lanceCross)。
// 2026-10-01 夜 前に出ない (ユーザー「前に出てから後ろに飛ぶのやっぱりおかしいよな。当たらなかったとしてもいいから前に出ずに
//   切り下がり薙ぎとして完成させてほしい」): 踏み込みの上限 90 → 0 = その場から跳び下がりながら払う (HOP_AT 0)。
//   光は横に流れる帯 (knight_spear_trail.ts・ユーザー選択「腰の高さで横に流れる帯」)。帯の高さは跳びの絵 (leap_swing) の槍なので、
//   払いの絵 (lanceSweep_contact・槍が高い) は挟まず構え → 跳びの絵へ直接替える (挟むと最初の 50ms だけ帯が槍の下に出た・実画面で確認)。
//   当たりは薙ぎと同じ穂先 110px のまま騎士と一緒に下がる = 主人公が穂先の外なら当たらない (ユーザー了承)。
//   踏み込みの仕組み (knightCrossLungePx) は 0 で残す (戻す時は LUNGE_MAX_PX を 90 に・HOP_AT を 150 に)。
export const KNIGHT_CROSS_LUNGE_MS = 150
// 2026-10-02 HOP_AT 0 → 70 (= 光が穂先へ走り切る KNIGHT_ARC_SWEEP_MS) (ユーザー「デフォルトで発動する距離感が悪いか、攻撃範囲が悪い」
//   「当たり判定と武器やエフェクトがあたっているように見えるように」): 払いと同時に跳ぶと、光が穂先に届く 70ms の間に騎士が 43px 下がり、
//   届く所が穂先 110px から 67px へ縮んでいた。払い切ってから跳ぶ (10-01 夕「当たる瞬間くらいから後ろに飛んでほしい」と同じ瞬間)。
export const KNIGHT_CROSS_HOP_AT_MS = KNIGHT_ARC_SWEEP_MS
export const KNIGHT_CROSS_LUNGE_MAX_PX = 0
/** 跳び始めの位置から前へ何 px にいるか (s = active に入ってからの ms・跳び下がると負)。 */
export function knightCrossForwardPx(s: number, lungePx: number, leapPx: number): number {
  const u = Math.min(1, Math.max(0, s) / KNIGHT_CROSS_LUNGE_MS)
  const lunge = lungePx * (1 - (1 - u) * (1 - u) * (1 - u))
  return lunge - (s >= KNIGHT_CROSS_HOP_AT_MS ? knightLeapDistance(s - KNIGHT_CROSS_HOP_AT_MS, leapPx) : 0)
}
/** 切り下がりの本体の浮き (s = active に入ってからの ms)。 */
export function knightCrossLiftY(s: number): number { return knightLeapLiftY(s - KNIGHT_CROSS_HOP_AT_MS) }
